import uuid from '@/util/uuid'

import config from '@/config'

// NOTE: define radio models that set range, min and max frequency?

export default ({
  id,
  isOn,
  locationX,
  locationY,
  frequency,
  maxFrequency,
  minFrequency,
  range
}) => {
  const normalizedMaxFrequency = Math.max((maxFrequency || 0), config.maxRadioTransmissionFrequency)
  const normalizedMinFrequency = Math.max((minFrequency || 0), config.minRadioTransmissionFrequency)

  return {
    id: id || uuid(),
    isOn: !!isOn,
    frequency: frequency ? (Math.min(Math.max(normalizedMinFrequency, (frequency || 0)), normalizedMaxFrequency)) : normalizedMinFrequency,
    locationX: Math.min(Math.max(0, (locationX || 0)), config.maxMapX),
    locationY: Math.min(Math.max(0, (locationY || 0)), config.maxMapY),
    maxFrequency: normalizedMaxFrequency,
    minFrequency: normalizedMinFrequency,
    range: Math.max(1, (range || 0))
  }
}
